module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Tools/Roulette-59654357e4e557cfb9b2c75e0b00eb3a.svg";